export const getTrendingSearchesPathForLocation = (
    slug: any,
    locale?: string,
    usesLanguageSubdirectory?: boolean,
): string => {
    const localePath = usesLanguageSubdirectory && locale ? `/${locale}` : '';
    return `${localePath}/trending/searches/${slug}/`;
};
